import { render, staticRenderFns } from "./PunchInDateTime.vue?vue&type=template&id=1645fec3&scoped=true&"
import script from "./PunchInDateTime.vue?vue&type=script&lang=js&"
export * from "./PunchInDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1645fec3",
  null
  
)

export default component.exports